import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import TonalButtonLarge from "./TonalBtnComponents/TonalButtonLarge";
import TonalButtonMedium from "./TonalBtnComponents/TonalButtonMedium";
import TonalButtonSmall from "./TonalBtnComponents/TonalButtonSmall";
import TonalButtonDisabled from "./TonalBtnComponents/TonalButtonDisabled";
import TonalButtonWithStartIcon from "./TonalBtnComponents/TonalButtonWithStartIcon";
import TonalButtonWithEndIcon from "./TonalBtnComponents/TonalButtonWithEndIcon";
import TonalBtnWithIcons from "./TonalBtnComponents/TonalBtnWithIcons";
import TonalLoadingButton from "./TonalBtnComponents/TonalLoadingButton";

const TonalButtons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Tonal Button
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          this is the button with lighter shade of background color.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <TonalButtonLarge />
          </Grid>
          <Grid item xs={6}>
            <TonalButtonMedium />
          </Grid>
          <Grid item xs={6}>
            <TonalButtonSmall />
          </Grid>
          <Grid item xs={6}>
            <TonalButtonDisabled />
          </Grid>
          <Grid item xs={6}>
            <TonalButtonWithStartIcon />
          </Grid>
          <Grid item xs={6}>
            <TonalButtonWithEndIcon />
          </Grid>
          <Grid item xs={6}>
            <TonalBtnWithIcons />
          </Grid>
          <Grid item xs={6}>
            <TonalLoadingButton />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default TonalButtons;
